"use strict";
/*
 * Created on 19. 9. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");

var utils_1 = require("../../core/utils");

var AbstractRelease_1 = require("../model/AbstractRelease");

var Release_1 = require("../model/Release");

var ReleaseType_1 = require("../model/ReleaseType");

var SelloutRelease_1 = require("../model/sellout/SelloutRelease");

var SelloutReleaseType_1 = require("../model/sellout/SelloutReleaseType");

var AbstractReleaseConverter_1 = require("./AbstractReleaseConverter");
/**
 * Default implementation of release converter.
 *
 * @author Radek Beran
 */


var AbstractReleaseConverterImpl =
/*#__PURE__*/
function (_AbstractReleaseConve) {
  _inherits(AbstractReleaseConverterImpl, _AbstractReleaseConve);

  function AbstractReleaseConverterImpl(releasePartConverter, selloutReleasePartConverter, userInfoConverter, editInfoConverter, validationResultConverter, realImpactValueConverter, selloutItemFilterConverter, selloutReleaseSnapshotConverter) {
    var _this;

    _classCallCheck(this, AbstractReleaseConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractReleaseConverterImpl).call(this));
    _this.releasePartConverter = releasePartConverter;
    _this.selloutReleasePartConverter = selloutReleasePartConverter;
    _this.userInfoConverter = userInfoConverter;
    _this.editInfoConverter = editInfoConverter;
    _this.validationResultConverter = validationResultConverter;
    _this.realImpactValueConverter = realImpactValueConverter;
    _this.selloutItemFilterConverter = selloutItemFilterConverter;
    _this.selloutReleaseSnapshotConverter = selloutReleaseSnapshotConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(AbstractReleaseConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      var releaseType = AbstractRelease_1.AbstractRelease.schemaBase.releaseType.valueOfField(source);
      var release;

      switch (releaseType) {
        case ReleaseType_1.ReleaseType.Sellout:
          release = new SelloutRelease_1.SelloutRelease(SelloutRelease_1.SelloutRelease.schema.id.valueOf(conversions.documentToClassId(source)), SelloutRelease_1.SelloutRelease.schema.name.valueOfField(source), SelloutRelease_1.SelloutRelease.schema.description.valueOfField(source), releaseType, SelloutRelease_1.SelloutRelease.schema.created.valueOfField(source), this.userInfoConverter.toObject(source.createdBy, conversions), SelloutRelease_1.SelloutRelease.schema.lastModified.valueOfField(source), this.userInfoConverter.toObject(source.lastModifiedBy, conversions), SelloutRelease_1.SelloutRelease.schema.priceListTypeId.valueOf(conversions.toClassReferenceId(source.priceListTypeId)), SelloutRelease_1.SelloutRelease.schema.priceListType.valueOfField(source), conversions.asEnum(source.selloutReleaseType, SelloutReleaseType_1.SelloutReleaseType), SelloutRelease_1.SelloutRelease.schema.productCategoryIds.valueOf(conversions.asObjectList(source, 'productCategoryIds', function (value) {
            return conversions.toClassReferenceId(value);
          })), utils_1.Utils.isValueMissing(source.itemFilter) ? null : this.selloutItemFilterConverter.toObject(source.itemFilter, conversions), conversions.asObjectList(source, 'releaseParts', function (rpDoc) {
            return _this2.selloutReleasePartConverter.toObject(rpDoc, conversions);
          }), SelloutRelease_1.SelloutRelease.schema.workflowType.valueOfField(source), SelloutRelease_1.SelloutRelease.schema.state.valueOfField(source), utils_1.Utils.isValueMissing(source.endDate) ? null : conversions.toDate(source.endDate), SelloutRelease_1.SelloutRelease.schema.calcWorkflowCaseId.valueOfField(source), SelloutRelease_1.SelloutRelease.schema.exportWorkflowCaseId.valueOfField(source), utils_1.Utils.isValueMissing(source.exportProgressMonitorId) ? null : conversions.toClassReferenceId(source.exportProgressMonitorId), SelloutRelease_1.SelloutRelease.schema.exported.valueOfField(source), SelloutRelease_1.SelloutRelease.schema.priceValidityStartDate.valueOfField(source), SelloutRelease_1.SelloutRelease.schema.totalPriceChangeLimit.valueOfField(source), utils_1.Utils.isValueMissing(source.minPriceChangeInPercent) ? null : conversions.toBigNumber(source.minPriceChangeInPercent), utils_1.Utils.isValueMissing(source.maxPriceChangeInPercent) ? null : conversions.toBigNumber(source.maxPriceChangeInPercent), utils_1.Utils.isValueMissing(source.minMarginChangeInPercent) ? null : conversions.toBigNumber(source.minMarginChangeInPercent), SelloutRelease_1.SelloutRelease.schema.cmDeadline.valueOfField(source), SelloutRelease_1.SelloutRelease.schema.favourite.valueOfField(source), utils_1.Utils.isValueMissing(source.validationResult) ? ValidationResult_1.ValidationResult.EMPTY : this.validationResultConverter.toObject(source.validationResult, conversions), SelloutRelease_1.SelloutRelease.schema.reopened.valueOfField(source), utils_1.Utils.isValueMissing(source.realImpact) ? null : this.realImpactValueConverter.toObject(source.realImpact, conversions), utils_1.Utils.isValueMissing(source.calcProgressMonitorId) ? null : SelloutRelease_1.SelloutRelease.schema.calcProgressMonitorId.valueOf(conversions.toClassReferenceId(source.calcProgressMonitorId)), SelloutRelease_1.SelloutRelease.schema.repricingEstimationThreshold.valueOfField(source), utils_1.Utils.isValueMissing(source.itemCountProgressMonitorId) ? null : conversions.toClassReferenceId(source.itemCountProgressMonitorId), utils_1.Utils.isValueMissing(source.computingProcessId) ? null : Release_1.Release.schema.computingProcessId.valueOf(source.computingProcessId), conversions.asObjectList(source, 'reopenSnapshots', function (value) {
            return _this2.selloutReleaseSnapshotConverter.toObject(value, conversions);
          })); // TODO RBe: Sellout. Better typing? (error: Type 'SelloutRelease' is not assignable to type 'T')

          break;

        default:
          release = new Release_1.Release(Release_1.Release.schema.id.valueOf(conversions.documentToClassId(source)), Release_1.Release.schema.name.valueOfField(source), Release_1.Release.schema.description.valueOfField(source), releaseType, Release_1.Release.schema.workflowType.valueOfField(source), Release_1.Release.schema.state.valueOfField(source), Release_1.Release.schema.pricingType.valueOfField(source), Release_1.Release.schema.sourceReleaseId.valueOf(conversions.toClassReferenceId(source.sourceReleaseId)), Release_1.Release.schema.priceZoneIds.valueOf(conversions.asObjectList(source, 'priceZoneIds', function (value) {
            return conversions.toClassReferenceId(value);
          })), Release_1.Release.schema.priceListTypeId.valueOf(conversions.toClassReferenceId(source.priceListTypeId)), Release_1.Release.schema.priceListType.valueOfField(source), conversions.asObjectList(source, 'productCategoryIds', function (value) {
            return conversions.toClassReferenceId(value);
          }), conversions.asObjectList(source, 'releaseParts', function (rpDoc) {
            return _this2.releasePartConverter.toObject(rpDoc, conversions);
          }), Release_1.Release.schema.created.valueOfField(source), this.userInfoConverter.toObject(source.createdBy, conversions), Release_1.Release.schema.lastModified.valueOfField(source), this.userInfoConverter.toObject(source.lastModifiedBy, conversions), Release_1.Release.schema.cmDeadline.valueOfField(source), Release_1.Release.schema.priceValidityStartDate.valueOfField(source), utils_1.Utils.isValueMissing(source.endDate) ? null : Release_1.Release.schema.endDate.valueOfField(source), Release_1.Release.schema.totalPriceChangeLimit.valueOfField(source), Release_1.Release.schema.exported.valueOfField(source), Release_1.Release.schema.calcWorkflowCaseId.valueOfField(source), Release_1.Release.schema.exportWorkflowCaseId.valueOfField(source), utils_1.Utils.isValueMissing(source.exportProgressMonitorId) ? null : Release_1.Release.schema.exportProgressMonitorId.valueOf(conversions.toClassReferenceId(source.exportProgressMonitorId)), utils_1.Utils.isObject(source.editInfo) ? this.editInfoConverter.toObject(source.editInfo, conversions) : null, Release_1.Release.schema.favourite.valueOfField(source), utils_1.Utils.isValueMissing(source.validationResult) ? ValidationResult_1.ValidationResult.EMPTY : this.validationResultConverter.toObject(source.validationResult, conversions), utils_1.Utils.isValueMissing(source.realImpact) ? null : this.realImpactValueConverter.toObject(source.realImpact, conversions), utils_1.Utils.isValueMissing(source.calcProgressMonitorId) ? null : Release_1.Release.schema.calcProgressMonitorId.valueOf(conversions.toClassReferenceId(source.calcProgressMonitorId)), utils_1.Utils.isValueMissing(source.computingProcessId) ? null : Release_1.Release.schema.computingProcessId.valueOf(source.computingProcessId)); // TODO RBe: Sellout. Better typing possible? (error: Type 'Release' is not assignable to type 'T')

          break;
      }

      return release;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        name: source.name
      });
      Object.assign(result, {
        description: source.description
      });
      Object.assign(result, {
        releaseType: source.releaseType
      });
      Object.assign(result, {
        workflowType: source.workflowType
      });
      Object.assign(result, {
        state: source.state
      });
      Object.assign(result, {
        priceListTypeId: source.priceListTypeId
      });
      Object.assign(result, {
        priceListType: source.priceListType
      });
      Object.assign(result, {
        productCategoryIds: conversions.asObjectArray(source, 'productCategoryIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        })
      });
      Object.assign(result, {
        created: conversions.fromDate(source.created)
      });
      Object.assign(result, {
        createdBy: this.userInfoConverter.toDocument(source.createdBy, conversions)
      });
      Object.assign(result, {
        lastModified: conversions.fromDate(source.lastModified)
      });
      Object.assign(result, {
        lastModifiedBy: this.userInfoConverter.toDocument(source.lastModifiedBy, conversions)
      });
      Object.assign(result, {
        priceValidityStartDate: source.priceValidityStartDate !== null ? conversions.fromDate(source.priceValidityStartDate) : null
      });
      Object.assign(result, {
        totalPriceChangeLimit: source.totalPriceChangeLimit
      });
      Object.assign(result, {
        calcWorkflowCaseId: source.calcWorkflowCaseId
      });
      Object.assign(result, {
        cmDeadline: utils_1.Utils.isMoment(source.cmDeadline) ? conversions.fromDate(source.cmDeadline) : null
      });
      Object.assign(result, {
        favourite: source.favourite
      });
      Object.assign(result, {
        validationResult: this.validationResultConverter.toDocument(source.validationResult, conversions)
      });
      Object.assign(result, {
        exportWorkflowCaseId: source.exportWorkflowCaseId
      });
      Object.assign(result, {
        exportProgressMonitorId: conversions.toDocumentReferenceId(source.exportProgressMonitorId)
      });
      Object.assign(result, {
        exported: utils_1.Utils.isMoment(source.exported) ? conversions.fromDate(source.exported) : null
      });

      if (source.realImpact) {
        Object.assign(result, {
          realImpact: this.realImpactValueConverter.toDocument(source.realImpact, conversions)
        });
      }

      Object.assign(result, {
        calcProgressMonitorId: conversions.toDocumentReferenceId(source.calcProgressMonitorId)
      });
      Object.assign(result, {
        computingProcessId: source.computingProcessId
      });

      if (Release_1.Release.isRegularRelease(source)) {
        // attributes specific for regular releases
        Object.assign(result, {
          priceZoneIds: conversions.asObjectArray(source, 'priceZoneIds', function (id) {
            return conversions.toDocumentReferenceId(id);
          })
        });
        Object.assign(result, {
          releaseParts: conversions.asObjectArray(source, 'releaseParts', function (releasePart) {
            return _this3.releasePartConverter.toDocument(releasePart, conversions);
          })
        });
        Object.assign(result, {
          pricingType: source.pricingType
        });
        Object.assign(result, {
          sourceReleaseId: conversions.toDocumentReferenceId(source.sourceReleaseId)
        });
        Object.assign(result, {
          editInfo: source.editInfo !== null ? this.editInfoConverter.toDocument(source.editInfo, conversions) : null
        });
        Object.assign(result, {
          endDate: source.endDate !== null ? conversions.fromDate(source.endDate) : null
        });
      }

      if (SelloutRelease_1.SelloutRelease.isSelloutRelease(source)) {
        // attributes specific for sellout releases
        Object.assign(result, {
          selloutReleaseType: source.selloutReleaseType
        });
        Object.assign(result, {
          releaseParts: conversions.asObjectArray(source, 'releaseParts', function (releasePart) {
            return _this3.selloutReleasePartConverter.toDocument(releasePart, conversions);
          })
        });
        Object.assign(result, {
          endDate: source.endDate !== null ? conversions.fromDate(source.endDate) : null
        });
        Object.assign(result, {
          minPriceChangeInPercent: source.minPriceChangeInPercent !== null ? conversions.fromBigNumber(source.minPriceChangeInPercent) : null
        });
        Object.assign(result, {
          maxPriceChangeInPercent: source.maxPriceChangeInPercent !== null ? conversions.fromBigNumber(source.maxPriceChangeInPercent) : null
        });
        Object.assign(result, {
          minMarginChangeInPercent: source.minMarginChangeInPercent !== null ? conversions.fromBigNumber(source.minMarginChangeInPercent) : null
        });
        Object.assign(result, {
          reopened: source.reopened
        });
        Object.assign(result, {
          itemFilter: source.itemFilter !== null ? this.selloutItemFilterConverter.toDocument(source.itemFilter, conversions) : null
        });
        Object.assign(result, {
          repricingEstimationThreshold: source.repricingEstimationThreshold
        });
        Object.assign(result, {
          itemCountProgressMonitorId: conversions.toDocumentReferenceId(source.itemCountProgressMonitorId)
        });
        Object.assign(result, {
          reopenSnapshots: conversions.asObjectArray(source, 'reopenSnapshots', function (value) {
            return _this3.selloutReleaseSnapshotConverter.toDocument(value, conversions);
          })
        });
      }

      return result;
    }
  }]);

  return AbstractReleaseConverterImpl;
}(AbstractReleaseConverter_1.AbstractReleaseConverter);

exports.AbstractReleaseConverterImpl = AbstractReleaseConverterImpl;